export default function checkIfCanSeeCertificatesRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  let exists = scopes.includes('certificates_list') || scopes.includes('certificates_company');
  return exists ? next() : next({ name: 'dashboard' });
}
